import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { priceInfo, gstTag } from "@/lib/format";
import { useSite } from "@/context/SiteContext";

export const PriceTag = ({ service, large = false }) => {
  const { site } = useSite();
  const p = priceInfo(service);
  const g = p.custom ? null : gstTag(site?.pricing, service.price_inr);
  return (
    <div data-testid={`price-${service.slug}`}>
      <p className="eb-label">{p.prefix}</p>
      <p className={`font-display font-black tracking-tighter text-white ${large ? "text-5xl md:text-6xl" : "text-3xl"} mt-1`}>
        {p.main}
        {p.unit && <span className="text-base font-medium text-zinc-500 tracking-normal ml-2">{p.unit}</span>}
      </p>
      {g && (
        <p className="mt-1 text-xs text-zinc-400" data-testid={`price-gst-${service.slug}`}>
          <span className="text-[#00E5FF] font-semibold">{g.short}</span>{g.total && <span className="text-zinc-500"> · {g.total}</span>}
        </p>
      )}
    </div>
  );
};

export const ServiceCard = ({ service, index }) => (
  <article
    className="group relative flex flex-col bg-[#121212] border border-[#27272A] p-8 md:p-10 transition-[border-color,transform] duration-300 hover:border-[#0055FF]/60 hover:-translate-y-1"
    data-testid={`service-card-${service.slug}`}
  >
    <div className="flex items-center justify-between">
      <span className="eb-label">{String(index + 1).padStart(2, "0")} / {service.category}</span>
      {!service.available && <span className="text-xs text-amber-400 border border-amber-400/40 px-2 py-1" data-testid={`service-unavailable-${service.slug}`}>Temporarily unavailable</span>}
    </div>
    <h3 className="mt-8 text-2xl md:text-3xl font-bold tracking-tight">{service.name}</h3>
    <p className="mt-3 text-zinc-400 leading-relaxed">{service.summary}</p>
    {service.deliverables?.length > 0 && (
      <ul className="mt-6 space-y-2">
        {service.deliverables.slice(0, 4).map((d) => (
          <li key={d} className="flex gap-2 text-sm text-zinc-300"><Check size={16} className="text-[#0055FF] mt-0.5 shrink-0" />{d}</li>
        ))}
      </ul>
    )}
    <div className="mt-auto pt-10 flex items-end justify-between gap-4">
      <PriceTag service={service} />
      {service.available && (
        <Link to={`/enquire?service=${service.slug}`} className="p-3 border border-white/15 group-hover:bg-[#0055FF] group-hover:border-[#0055FF] transition-colors" aria-label={`Enquire about ${service.name}`} data-testid={`service-enquire-${service.slug}`}>
          <ArrowUpRight size={20} />
        </Link>
      )}
    </div>
  </article>
);
